import { INPUT_VALIDATION_IN_ARRAY } from "../../../enums/Request/currentRequestControls.types";

export const inputValidationInArray = (data) => {
    return {
        type: INPUT_VALIDATION_IN_ARRAY,
        payload: data,
    };
};
